import { call, put, takeLatest } from 'redux-saga/effects';
import { getIncomesTabStatus } from '../../services/API';
import {
  actionTypes,
  requestFailure,
  requestSuccess,
} from 'modules/UserIncomes/redux/userIncomes/actions';

function* getData() {
  const response = yield call(getIncomesTabStatus);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* ndfl2Saga() {
  yield takeLatest(actionTypes.TABS_STATUS_REQUEST_START, getData);
}
